<template>
	<validation-provider
		#default="{ errors }"
		:name="fieldName || $props.label"
		:rules="rules"
		:mode="validationMode"
		:custom-messages="customMessages"
		tag="div"
		:class="tooltipText || reserveTooltipSpace ? 'd-flex flex-row cassie-horizontal-sm align-baseline' : ''"
	>
		<div class="textarea-wrapper">
			<v-textarea
				v-bind="$props"
				:readonly="viewOnly"
				:persistent-placeholder="viewOnly"
				:error-messages="errors.length ? [errors[0]] : []"
				:class="getQaSelectorClass($props)"
				:rules="[]"
				outlined
				:hide-details="!errors.length"
				:data-testid="testId"
				v-on="$listeners"
			/>
			<div
				v-if="explainer"
				class="textarea-explainer"
			>
				{{ explainer }}
			</div>
		</div>
		<v-tooltip
			v-if="tooltipText"
			top
		>
			<template #activator="{ on }">
				<v-icon
					light
					v-on="on"
				>
					mdi-information
				</v-icon>
			</template>
			<span>
				{{ tooltipText }}
			</span>
		</v-tooltip>
		<div
			v-if="reserveTooltipSpace"
			style="width: 24px;"
		/>
	</validation-provider>
</template>

<script>
import { VTextarea } from 'vuetify/lib'
import FieldValidationMixin from '../validation/field-validation-mixin.js'

export default {
	name: 'text-area',
	extends: VTextarea,
	mixins: [FieldValidationMixin],
	props: {
		tooltipText: {
			type: String
		},
		viewOnly: {
			type: Boolean,
			default: false
		},
		testId: {
			type: String,
			default: 'cassie_textarea'
		},
		reserveTooltipSpace: {
			type: Boolean,
			default: false
		},
		explainer: {
			type: String
		}
	},
	methods: {
		getQaSelectorClass (props) {
			let trimmedLabel = props.label
			if (trimmedLabel) {
				if (trimmedLabel.includes(' *')) {
					trimmedLabel = trimmedLabel.replace(' *', '')
				}
				trimmedLabel = trimmedLabel.replace(/\s/g, '-').toLowerCase()
			}
			return `qa-textarea-${trimmedLabel}`
		}
	}
}
</script>

<style lang="scss" scoped>
.textarea-wrapper {
	flex: 1;
}

.textarea-explainer {
	font-size: 0.75rem;
	font-family: 'Inter', sans-serif;
	color: var(--global-muted-foreground);
	margin-top: 4px;
	line-height: 1.4;
}

.v-textarea {
	// Label font size - aligned with NextJS (text-sm = 0.875rem, font-medium = 500)
	.v-label {
		font-size: 0.875rem !important;
		font-family: 'Inter', sans-serif;
		font-weight: 500;
	}

	// Content/input text font size - aligned with NextJS (text-sm = 0.875rem)
	.v-textarea__wrapper textarea {
		font-size: 0.875rem !important;
		font-family: 'Inter', sans-serif;
		font-weight: 400;
	}

	// Placeholder text font size
	.v-textarea__wrapper textarea::placeholder {
		font-size: 0.875rem !important;
		font-family: 'Inter', sans-serif;
	}

	// Change focus/active outline color from primary to syrenis-black
	&.v-input--is-focused .v-input__slot {
		border-color: var(--global-syrenis-black) !important;
	}

	&.v-input--is-focused .v-input__slot fieldset {
		border-color: var(--global-syrenis-black) !important;
	}

	&.v-input--is-focused:not(.v-input--has-state) .v-label {
		color: var(--global-syrenis-black) !important;
	}

	// Change cursor color to syrenis-black
	textarea {
		caret-color: var(--global-syrenis-black) !important;
	}

	// Also target the outlined variant specifically
	&.v-text-field--outlined.v-input--is-focused .v-input__slot fieldset {
		border-color: var(--global-syrenis-black) !important;
	}

	&.v-text-field--outlined.v-input--is-focused:not(.v-input--has-state) .v-input__slot fieldset {
		border-color: var(--global-syrenis-black) !important;
	}
}
// Input background - white in light mode, dark background in dark mode
.v-input__slot {
	background-color: var(--global-card-background) !important;
}
</style>
